// static constants
import TimerEvent from '../../../bits/timer/timer-event';

export default class GalleryImages {

	static selector = 'gallery-images';

	// class variables

	el = {};

	states = {
		activeItem: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			controls: container.querySelector(`.${this.constructor.selector}__controls`),
			imageWrapper: container.querySelector(`.${this.constructor.selector}__image-wrapper`),
			imagePicture: container.querySelector(`.${this.constructor.selector}__image picture`),
			image: container.querySelector(`.${this.constructor.selector}__image img`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		this.el.controls.addEventListener(TimerEvent.CHANGING, this.#onTimerItemChanging);
		this.el.controls.addEventListener(TimerEvent.POLLING, this.#onTimerItemPolling);
		this.el.controls.dispatchEvent(new CustomEvent(TimerEvent.POLL_STATUS));
	}

	#removeEventListeners = () => {

	}

	// listener methods

	#onTimerItemChanging = (e) => {
		const $target = e.detail.target;
		this.checkCurrentItem($target);
	}

	#onTimerItemPolling = (e) => {
		const $target = e.detail.target;
		this.checkCurrentItem($target);
	}

	checkCurrentItem($target) {
		if (this.states.activeItem !== $target) {
			const data = JSON.parse(decodeURIComponent($target.getAttribute('data-action')));

			const sourcesImage = [...this.el.imagePicture.children];
			for (let i = 0; i < sourcesImage.length; i++) {
				const source = sourcesImage[i];
				source.remove();
			}

			// update picture (image)
			const imgPosterDesktop = document.createElement('img');
			imgPosterDesktop.setAttribute('src', data.image);
			imgPosterDesktop.setAttribute('alt', data.alt);
			this.el.imagePicture.appendChild(imgPosterDesktop);

			const srcPosterDesktop = document.createElement('source');
			srcPosterDesktop.setAttribute('srcset', data.image);
			srcPosterDesktop.setAttribute('media', '(max-width: 768px)');
			this.el.imagePicture.appendChild(srcPosterDesktop);

			const srcPosterTablet = document.createElement('source');
			srcPosterTablet.setAttribute('srcset', data.imageTablet);
			srcPosterDesktop.setAttribute('media', '(max-width: 480px)');
			this.el.imagePicture.appendChild(srcPosterTablet);

			const srcPosterMobile = document.createElement('source');
			srcPosterMobile.setAttribute('srcset', data.imageMobile);
			srcPosterDesktop.setAttribute('media', '(max-width: 479px)');
			this.el.imagePicture.appendChild(srcPosterMobile);

			// set active state
			this.states.activeItem = $target;
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
